import clsx from 'clsx';
import { motion } from 'framer-motion';
import React from 'react';
import { Link } from 'react-router-dom';

import { ChevronRightIcon } from '../Icon';
import { colors } from '@/const/colors';
import { IMAGE_BASE_URL } from '@/const/url';

interface SubCardsProps {
  cards: ButtonCard[];
  // licenseCount: number;
  // jobCount: number;
}

export default function SubCards({ cards }: SubCardsProps) {
  const handleSaveEntryPoint = () => {
    sessionStorage.setItem('entryPoint', location.pathname);
  };

  return (
    <>
      {/* <div className="grid grid-cols-4 bg-gray-0 shadow-soft mx-4 rounded-[12px] sm280:hidden sm360:hidden">
        {cards.map((item, index) => (
          <div key={index} className={'flex justify-center items-center relative'}>
            {index > 0 && <div className={'border-l border-gray-3 h-[36px]'}></div>}

            <Link
              to={item.path}
              className={clsx(
                'flex p-3 items-center justify-center relative rounded-[12px] w-full',
                index > 2 && 'sm280:hidden',
              )}
              onClick={handleSaveEntryPoint}
            >
              <div className="flex flex-col items-center justify-end w-full">
                <div className="flex justify-center items-center relative w-[40px] h-[40px]">
                  {item.icon}
                  {item.title === '번호판거래' && licenseCount > 0 && (
                    // <b className="bg-primary-3 border-[3px] border-gray-0 p-1 w-7 h-7 absolute top-[-5px] right-[-20px] rounded-full flex items-center justify-center">
                    //   <span className="text-[14px] text-primary-10">{licenseCount}</span>
                    // </b>
                    <motion.button
                      className="border-[3px] border-gray-0 p-1 w-7 h-7 absolute top-[-5px] right-[-20px] rounded-full flex items-center justify-center bg-[#FB2C36] text-white text-[12px] font-semibold whitespace-nowrap"
                      animate={{
                        boxShadow: ['0 0 0 0 rgba(239, 68, 68, 0.4)', '0 0 0 10px rgba(239, 68, 68, 0)'],
                      }}
                      transition={{
                        duration: 1.5,
                        repeat: Infinity,
                      }}
                    >
                      {licenseCount}
                    </motion.button>
                  )}
                  {item.title === '일자리구하기' && jobCount > 0 && (
                    <motion.button
                      className="border-[3px] border-gray-0 p-1 w-7 h-7 absolute top-[-5px] right-[-16px] rounded-full flex items-center justify-center bg-[#FB2C36] text-white text-[12px] font-semibold whitespace-nowrap"
                      animate={{
                        boxShadow: ['0 0 0 0 rgba(239, 68, 68, 0.4)', '0 0 0 10px rgba(239, 68, 68, 0)'],
                      }}
                      transition={{
                        duration: 1.5,
                        repeat: Infinity,
                      }}
                    >
                      {jobCount}
                    </motion.button>
                  )}
                </div>
                <span className="font-semibold text-gray-8 text-[15px] text-center sm280:text-[12px] mt-2">
                  {item.title}
                </span>
              </div>
            </Link>
          </div>
        ))}
      </div> */}

      <div className="pb-6">
        <div className="px-4 py-[12px] ">
          <h2 className="text-[20px] font-semibold text-gray-8">더 많은 서비스</h2>
        </div>
        {cards.map((item, index) => (
          <div key={index} className={`flex justify-center items-center relative`}>
            <Link
              to={item.path}
              className="px-4 py-[10px] flex items-center justify-between w-full"
              onClick={handleSaveEntryPoint}
            >
              <div className="flex flex-row items-center justify-between w-full">
                <div className="flex items-center gap-3">
                  <div className="flex justify-center items-center w-[40px] h-[40px]">
                    <img src={`${IMAGE_BASE_URL}/${item.icon}`} alt={item.title} width={40} height={40}></img>
                  </div>
                  <div>
                    <p className="text-gray-7 text-[12px] leading-[15px] mb-[4px]">{item.subTitle}</p>
                    <div className="font-semibold text-gray-8 text-[16px] leading-[24px]">{item.title}</div>
                  </div>
                </div>
                <ChevronRightIcon color={colors.gray[7]} width={24} height={24}></ChevronRightIcon>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
}
